/** Packages **/
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardText } from 'material-ui/Card';
import LinearCalendarHeader from './LinearCalendarHeader';
import LinearCalendarTable from './LinearCalendarTable';
import OpenTimeSearch from '../OpenTimeSearch';

import './styles.scss';

const LinearCalendar = props => {
  const [fromAddButton, setFromAddButton] = useState(false);
  const contentStyles = {
    padding: '0'
  };

  const updateFromAddButton = (newVal) => {
    setFromAddButton(newVal);
  };

  const {
    bidPreferencesTotalEntries,
    handleActionPreference,
    showNotification,
    bidSessionId,
    preferenceHasChange,
    requestAll,
    reportMode = false
  } = props;
  return (
    <Card className='Calendar' id='calendar-card'>
      <LinearCalendarHeader head={props.head} />
      <CardText style={contentStyles}>

        <LinearCalendarTable
          bidSession={props.bidSession}
          totalEntries={props.totalEntries}
          handleActionPreference={handleActionPreference}
          startDate={props.startDate}
          endDate={props.endDate}
          showNotification={showNotification}
          calendarStartDateStr={props.calendarStartDateStr}
          calendarEndDateStr={props.calendarEndDateStr}
          totalDaysInCalendar={props.totalDaysInCalendar}
          bidPreferencesTotalEntries={bidPreferencesTotalEntries}
          requestAll={requestAll}
          reportMode={reportMode}
        />
        <OpenTimeSearch
          bidSession={props.bidSession}
          bidStartDate={props.startDate}
          bidEndDate={props.endDate}
          bidPreferencesTotalEntries={bidPreferencesTotalEntries}
          handleActionPreference={handleActionPreference}
          showNotification={showNotification}
          bidSessionId={bidSessionId}
          preferenceHasChange={preferenceHasChange}
          calendarStartDateStr={props.calendarStartDateStr}
          calendarEndDateStr={props.calendarEndDateStr}
          totalDaysInCalendar={props.totalDaysInCalendar}
          fromAddButton={fromAddButton}
          setFromAddButton={updateFromAddButton}
        />
      </CardText>
    </Card>
  );
};

LinearCalendar.propTypes = {
  calendarStartDateStr: PropTypes.any,
  calendarEndDateStr: PropTypes.any,
  totalDaysInCalendar: PropTypes.number,
  startDate: PropTypes.array,
  endDate: PropTypes.array,
  head: PropTypes.any.isRequired,
  bidPreferencesTotalEntries: PropTypes.func.isRequired,
  handleActionPreference: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  bidSessionId: PropTypes.string.isRequired,
  preferenceHasChange: PropTypes.bool,
  bidSession: PropTypes.shape({
    currentBid: PropTypes.object,
    bidPreferences: PropTypes.object
  }),
  totalEntries: PropTypes.number,
  otherOptions: PropTypes.object.isRequired
};

LinearCalendar.defaultProps = {
  calendarStartDateStr: null,
  calendarEndDateStr: null,
  totalDaysInCalendar: 28,
  startDate: [],
  endDate: [],
  preferenceHasChange: false,
  totalEntries: 0
};

export default LinearCalendar;
